(function (angular) {
    angular.module('bizPartEngage').directive('bizHeader', bizHeaderDirective);
    angular.module('bizPartEngage').directive('bizGlobalSiteTitle', bizGlobalSiteTitleDirective);

    bizHeaderDirective.$inject = ["bizCore"];
    bizGlobalSiteTitleDirective.$inject = [];

    function bizGlobalSiteTitleDirective() {
        var directive = {
            restrict: "E",
            scope: {
            },
            template: '<span ng-if="vm.SiteTitle" ng-bind="vm.SiteTitle"></span>',
            controller: bizGlobalSiteTitleController,
            controllerAs: "vm"
        }

        bizGlobalSiteTitleController.$inject = ["base.service"];

        function bizGlobalSiteTitleController(baseService) {
            var vm = this;

            baseService.GetGlobalSiteTitle().then(function (response) {
                vm.SiteTitle = response.data;
            });
        }

        return directive;
    }

    function bizHeaderDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
            },
            templateUrl: bizCoreProvider.getView('core.directives.header', "FrontEnd/Core/Directives/Views/Header.html"),
            controller: bizHeaderController,
            controllerAs: "vm"
        }

        bizHeaderController.$inject = ["core.users.service", "bizCoreService", "$window", "$filter", "$rootScope", "$element"];

        function bizHeaderController(userService, bizCoreService, $window, $filter, $rootScope, $element) {
            var vm = this;
            vm.logo = portalSettings['logo'];
            vm.lastScrollTop = 0;
            vm.scrollTop = 0;
            vm.scrollDirection = '';

            vm.ShowLogin = false;
            vm.ShowFavorites = false;
            vm.ShowSearch = false;
            vm.ShowCultures = false;

            this.GoToAdmin = GoToAdmin;
            this.Logout = Logout;
            this.Search = Search;
            this.ChangeCulture = ChangeCulture;
            this.ToggleCollapseHeader = ToggleCollapseHeader;
            this.Init = Init;
            this.ClickOutsideMenu = ClickOutsideMenu;

            $rootScope.$watch('MiniSettings.Header.KeepBgClass',
                function (newVal, oldVal) {
                    if (newVal && newVal != oldVal) {
                        if ($rootScope.MiniSettings.Header.KeepBgClass === true)
                            AddBgClass();
                        else
                            RemoveBgClass();
                    }
                }
            );

            $rootScope.$on('CLOSE_ALL_MENUS', function (event, args) {
                CloseAllMenus();
            });

            $rootScope.$on('HIDE-LOGIN-DIRECTIVE', function (event, args) {
                vm.ShowLogin = false;
                $rootScope.$digest();
            });

            $rootScope.$on('SHOW-LOGIN-DIRECTIVE', function (event, args) {
                vm.ShowLogin = true;
                $rootScope.$digest();
            });

            function HighLightItem(showOverlay) {
                if (showOverlay === true) {
                    angular.element('#base-home').addClass('highlight-header-item');
                }
                else {
                    angular.element('#base-home').removeClass('highlight-header-item');
                }
            }

            function ClickOutsideMenu() {
                vm.ShowLogin = false;
                HighLightItem(false);

                $rootScope.$broadcast('CLICK_OUTSIDE_MENU');
            }

            function CloseAllMenus() {
                if (vm.ShowLogin || vm.ShowFavorites || vm.ShowSearch || vm.ShowCultures) {
                    vm.ShowLogin = false;
                    vm.ShowFavorites = false;
                    vm.ShowSearch = false;
                    vm.ShowCultures = false;
                }

                $rootScope.$digest();
            }

            function GoToAdmin() {
                $window.location.href = $filter('siteroot')('/admin');
            }

            function Logout() {
                console.log("logout btn")
                userService.Logout();
            }

            function Search(searchText) {
            	return bizCoreService.Search(searchText).then(function (response) {
            		return response.data;
            	});
            }

            function ChangeCulture(culture) {
                if (culture.QueryString)
                {                    
                    $window.location.href = $filter('siteroot')('/' + culture.QueryString);
                }
            }

            function ToggleCollapseHeader() {
                $element.parent().toggleClass('collapsed');
            }

            function onScroll() {
                vm.scrollTop = $window.pageYOffset || document.documentElement.scrollTop;
                vm.scrollDirection = vm.lastScrollTop < vm.scrollTop ? 'down' : 'up';

                if (vm.scrollDirection === 'down' && vm.scrollTop > 5 && $rootScope.MiniSettings["Header"]["PreventHideOnScroll"] === false) { // iOS fix 5px
                    angular.element('.biz-header').addClass('hide-menu');
                }
                else {
                    angular.element('.biz-header').removeClass('hide-menu');
                }

                var offsetLimit = 0;
                var offsetElement = angular.element('#header-bg-offset');
                if (offsetElement.length > 0 && offsetElement[0].offsetTop > 0) {
                    var logoHeight = angular.element('.biz-site-logo-wrapper')[0].clientHeight;
                    offsetLimit = offsetElement[0].offsetTop - (logoHeight !== undefined ? logoHeight : 0);
                }

                if (vm.scrollTop > offsetLimit) {
                    AddBgClass();
                    CloseAllMenus();
                }
                else if ($rootScope.MiniSettings["Header"]["KeepBgClass"] === false) {
                    RemoveBgClass();
                }
                vm.lastScrollTop = vm.scrollTop;
            }

            function Init() {
                vm.ShowTipSomeone = portalSettings['IsShowTipSomeoneEnabled'];
                vm.OpenIdProviderId = portalSettings["loginopenidp"];

                console.log("vm.OpenIdProviderId", vm.OpenIdProviderId)

                if ($rootScope.MiniSettings.Header.KeepBgClass === true)
                    AddBgClass();

                $window.addEventListener('scroll', onScroll);

                if (isSessionStorageTrue('highlightLogin')) {
                    vm.ShowLogin = true;
                    HighLightItem(true);
                    deleteSessionStorage('highlightLogin');
                }
            }

            function AddBgClass() {
                //console.log('AddBgClass');
                angular.element('.biz-header').addClass('menu-w-bg');
            }

            function RemoveBgClass() {
                //console.log('RemoveBgClass');
                angular.element('.biz-header').removeClass('menu-w-bg');
            }

            this.$onInit = vm.Init;   
        }

        return directive;
    }
})(window.angular);
